module.exports = __webpack_public_path__ + "img/plc_hmi_scada.83418cbf.jpg";